/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aloof_Tense_Racoon_TreatInputs */

const en_aloof_tense_racoon_treat = /** @type {(inputs: Aloof_Tense_Racoon_TreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search labels...`)
};

const de_aloof_tense_racoon_treat = /** @type {(inputs: Aloof_Tense_Racoon_TreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels durchsuchen...`)
};

/**
* | output |
* | --- |
* | "Search labels..." |
*
* @param {Aloof_Tense_Racoon_TreatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const aloof_tense_racoon_treat = /** @type {((inputs?: Aloof_Tense_Racoon_TreatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aloof_Tense_Racoon_TreatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aloof_tense_racoon_treat(inputs)
	return de_aloof_tense_racoon_treat(inputs)
});